// import { ModuleWithProviders, NgModule } from "@angular/core";
// import { CommonModule } from "@angular/common";

// import {
//   NbActionsModule,
//   NbLayoutModule,
//   NbMenuModule,
//   NbSearchModule,
//   NbSidebarModule,
//   NbUserModule,
//   NbContextMenuModule,
//   NbButtonModule,
//   NbCardModule,
//   NbSelectModule,
//   NbIconModule,
//   NbThemeModule,
// } from "@nebular/theme";

// import { NbEvaIconsModule } from "@nebular/eva-icons";
// import { NbSecurityModule } from "@nebular/security";

// import { FooterComponent, HeaderComponent } from "./components";

// import {
//   CapitalizePipe,
//   PluralPipe,
//   RoundPipe,
//   TimingPipe,
//   NumberWithCommasPipe,
// } from "./pipes";

// import { OneColumnLayoutComponent } from "./layouts";

// import { DEFAULT_THEME } from "./styles/theme.default";
// import { COSMIC_THEME } from "./styles/theme.cosmic";
// import { CORPORATE_THEME } from "./styles/theme.corporate";
// import { DARK_THEME } from "./styles/theme.dark";

// import { DebounceFilterDirective } from "./directives/debounce-filter.directive";

// import { TranslateModule } from "@ngx-translate/core";

// import { GoogleMapAutocompleteDirective } from "./directives/google-map-autocomplete.directive";

// import { NoAccessPageComponent } from "./components/no-access-page/no-access-page.component";

// import { OrderHeaderDropdownComponent } from "../admin/order-header-dropdown/order-header-dropdown.component";




// const NB_MODULES = [
//   NbLayoutModule,
//   NbMenuModule,
//   NbUserModule,
//   NbActionsModule,
//   NbSearchModule,
//   NbSidebarModule,
//   NbContextMenuModule,
//   NbSecurityModule,
//   NbButtonModule,
//   NbSelectModule,
//   NbIconModule,
//   NbCardModule,
//   NbEvaIconsModule,
// ];


// const COMPONENTS = [
//   HeaderComponent,
//   FooterComponent,
//   OneColumnLayoutComponent,
//   NoAccessPageComponent,
//   OrderHeaderDropdownComponent,
// ];


// const PIPES = [
//   CapitalizePipe,
//   PluralPipe,
//   RoundPipe,
//   TimingPipe,
//   NumberWithCommasPipe,
// ];


// @NgModule({
//   imports: [
//     CommonModule,
//     TranslateModule,
//     ...NB_MODULES


//   ],

//   exports: [
//     GoogleMapAutocompleteDirective,
//     CommonModule,
//     ...PIPES,
//     ...COMPONENTS,

//     // Optional, but useful if other modules need the dropdown
//   ],

//   declarations: [
//     ...COMPONENTS,
//     ...PIPES,
//     DebounceFilterDirective,
//     GoogleMapAutocompleteDirective,
//   ],
// })
// export class ThemeModule {

//   static forRoot(): ModuleWithProviders<ThemeModule> {
//     return {
//       ngModule: ThemeModule,
//       providers: [
//         ...NbThemeModule.forRoot(
//           {
//             name: "default",
//           },
//           [DEFAULT_THEME, COSMIC_THEME, CORPORATE_THEME, DARK_THEME]
//         ).providers,
//       ],
//     };
//   }
// }




import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import {
  NbActionsModule,
  NbLayoutModule,
  NbMenuModule,
  NbSearchModule,
  NbSidebarModule,
  NbUserModule,
  NbContextMenuModule,
  NbButtonModule,
  NbCardModule,
  NbSelectModule,
  NbIconModule,
  NbThemeModule,
} from "@nebular/theme";

import { NbEvaIconsModule } from "@nebular/eva-icons";
import { NbSecurityModule } from "@nebular/security";

import { FooterComponent, HeaderComponent } from "./components";

import {
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
} from "./pipes";

import { OneColumnLayoutComponent } from "./layouts";

import { DEFAULT_THEME } from "./styles/theme.default";
import { COSMIC_THEME } from "./styles/theme.cosmic";
import { CORPORATE_THEME } from "./styles/theme.corporate";
import { DARK_THEME } from "./styles/theme.dark";

import { DebounceFilterDirective } from "./directives/debounce-filter.directive";

import { TranslateModule } from "@ngx-translate/core";

import { GoogleMapAutocompleteDirective } from "./directives/google-map-autocomplete.directive";

import { NoAccessPageComponent } from "./components/no-access-page/no-access-page.component";

import { OrderHeaderDropdownComponent } from "../admin/order-header-dropdown/order-header-dropdown.component";

// 🔧 NEW — provider-panel equivalent of OrderHeaderDropdownComponent.
// Adjust this import path to wherever you actually placed the
// provider-header-dropdown folder (mirrors the admin one above).
import { ProviderHeaderDropdownComponent } from "../provider/provider-header-dropdown/provider-header-dropdown.component";


const NB_MODULES = [
  NbLayoutModule,
  NbMenuModule,
  NbUserModule,
  NbActionsModule,
  NbSearchModule,
  NbSidebarModule,
  NbContextMenuModule,
  NbSecurityModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbCardModule,
  NbEvaIconsModule,
];


const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  OneColumnLayoutComponent,
  NoAccessPageComponent,
  OrderHeaderDropdownComponent,
  ProviderHeaderDropdownComponent, // 🔧 NEW
];


const PIPES = [
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
];


@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    ...NB_MODULES


  ],

  exports: [
    GoogleMapAutocompleteDirective,
    CommonModule,
    ...PIPES,
    ...COMPONENTS,

    // Optional, but useful if other modules need the dropdown
  ],

  declarations: [
    ...COMPONENTS,
    ...PIPES,
    DebounceFilterDirective,
    GoogleMapAutocompleteDirective,
  ],
})
export class ThemeModule {

  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        ...NbThemeModule.forRoot(
          {
            name: "default",
          },
          [DEFAULT_THEME, COSMIC_THEME, CORPORATE_THEME, DARK_THEME]
        ).providers,
      ],
    };
  }
}